
























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import {
  TicketSetting,
  IPlanSummaryData,
  PlanUnit,
  IssuingRule,
  IssuingRuleId,
  BookingTypeEnum,
  IssuableDate,
  IssuableDateBaseDateTypeEnum,
  IDate,
  TimePeriod,
  TimePeriodUnitEnum,
  IUserTokenData,
  LanguageEnum,
  TicketStatusEnum,
  I18nText,
  MogiriSettingCode,
  MogiriSettingCautionLabel,
} from '@/api/types';
import {
  IListTicketSettingsRequest,
  listTicketSettings,
  IPutTicketSettingRequest,
  putTicketSetting,
  IListPlansRequest,
  listPlans,
} from '@/api/tickets';
import {
  formatApiError,
  compareString,
  stringToIDate,
  stringFromIDate,
  formatDate,
  stringToNumber,
  supportedTravelerLangs,
  supportedTicketStatus,
  timeToSeconds,
  secondsToTime,
} from '@/utils/index';
import {
  planToText,
  ticketToText,
  TicketType,
  newDefaultTicketSetting,
} from '@/utils/tickets';
import { translateRouteTitle } from '@/utils/permission';

type ItemType = {
  text: string;
  value: string;
};

type WithIssuableDates = {
  issuableFromDates: string[];
  issuableFromOptDates: string[];
  issuableToDates: string[];
  issuableToOptDates: string[];
};

type WithIsActive = {
  isActive: boolean;
};

@Component({
  name: 'TicketSettingCreate',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  private planTitle = '';
  private unitTitle = '';
  private loading = true;
  private valid = false;
  private editingTicketSetting: TicketSetting &
    WithIssuableDates &
    WithIsActive = {
    issuableFromDates: [],
    issuableFromOptDates: [],
    issuableToDates: [],
    issuableToOptDates: [],
  } as any;
  private langItems: ItemType[] = [];
  private ticketStatusItems: ItemType[] = [];
  private plansByPlanId: Map<string, IPlanSummaryData> = new Map();
  private planItems: ItemType[] = [];
  private planUnitByPlanIdAndUnitId: Map<
    string,
    Map<string, PlanUnit>
  > = new Map();
  private unitItems: ItemType[] = [];
  private ticketSettingsByTicketId: Map<string, TicketSetting> = new Map();
  private ticketItems: ItemType[] = [];
  private ticketTextByTicketId: Map<string, string> = new Map();
  private fromDateMenus: boolean[] = [];
  private fromOptDateMenus: boolean[] = [];
  private toDateMenus: boolean[] = [];
  private toOptDateMenus: boolean[] = [];
  private redirectAfterCreate = true;
  private showRedirectAfterCreate = true;
  private dialog = false;
  private dialogConfirmHandler = this.resetDialog;
  private dialogTextTitle = '';
  private dialogTextFooter = '';
  private showCopyTicketSettings = false;
  private canCopyTicketSettings = false;
  private copyTicketSettingId = '';
  private enableMogiri = true;

  get isDialogFullscreen() {
    return false && this.$vuetify.breakpoint.smAndDown;
  }

  get issuingRuleItems() {
    return Object.values(IssuingRuleId)
      .filter(
        r =>
          (r as IssuingRuleId) !== IssuingRuleId.UNKNOWN_RULE &&
          (r as IssuingRuleId) !== IssuingRuleId.LIMITED_ISSUING
      )
      .map(r => ({
        text: this.$t(`IssuingRuleId.${r}`),
        value: r as string,
      }));
  }

  get issuableDateBaseItems() {
    return Object.values(IssuableDateBaseDateTypeEnum)
      .filter(
        b =>
          (b as IssuableDateBaseDateTypeEnum) !==
          IssuableDateBaseDateTypeEnum.UNKNOWN_DATE
      )
      .map(b => ({
        text: this.$t(`IssuableDateBaseDateTypeEnum.${b}`),
        value: b as string,
      }));
  }

  get timePeriodUnitItems() {
    return Object.values(TimePeriodUnitEnum)
      .filter(u => (u as TimePeriodUnitEnum) !== TimePeriodUnitEnum.UNKNOWN)
      .map(u => ({
        text: this.$t(`TimePeriodUnitEnum.${u}`),
        value: u as string,
      }));
  }

  get canUpdatePlan() {
    return true;
  }

  get canUpdateUnit() {
    return true;
  }

  get canCreate() {
    return this.valid;
  }

  created() {
    this.loadLangItems();
    this.loadTicketStatus();
    this.fetchData();
    this.reset();
  }

  private loadLangItems() {
    const langItems: ItemType[] = [];
    supportedTravelerLangs.forEach(l => {
      langItems.push({
        value: l,
        text: this.$t(`LanguageEnum.${l}`) as string,
      });
    });
    this.langItems = langItems;
  }

  private loadTicketStatus() {
    const ticketStatusItems: ItemType[] = [];
    supportedTicketStatus.forEach(t => {
      ticketStatusItems.push({
        value: t,
        text: this.$t(`TicketStatusEnum.${t}`) as string,
      });
    });
    this.ticketStatusItems = ticketStatusItems;
  }

  private async fetchData(noLoading = false) {
    if (!noLoading) {
      this.loading = true;
      AppModule.StartProgress();
    }

    await Promise.all([
      this.fetchThenLoadPlans(),
      this.fetchThenLoadTicketSetting(),
    ]);
    this.loadTicketItems();

    if (!noLoading) {
      this.loading = false;
      AppModule.StopProgress();
    }
  }

  private async fetchThenLoadPlans() {
    const res = await listPlans({});
    this.plansByPlanId = new Map(res.plans.map(p => [p.planId, p]));

    const planItems: ItemType[] = [];
    this.plansByPlanId.forEach(p => {
      planItems.push({
        text: planToText(this.$i18n, p),
        value: p.planId,
      });

      if (!this.planUnitByPlanIdAndUnitId.has(p.planId)) {
        this.planUnitByPlanIdAndUnitId.set(p.planId, new Map());
      }
      this.planUnitByPlanIdAndUnitId.set(p.planId, new Map());
    });
    this.planItems = planItems.sort((a, b) => compareString(a.text, b.text));

    this.loadUnitItems();
  }

  private loadUnitItems(clearUnitId = false) {
    clearUnitId && (this.editingTicketSetting.unitId = '');

    this.planUnitByPlanIdAndUnitId = new Map();
    this.plansByPlanId.forEach(p => {
      if (!this.planUnitByPlanIdAndUnitId.has(p.planId)) {
        this.planUnitByPlanIdAndUnitId.set(p.planId, new Map());
      }
      const units = this.planUnitByPlanIdAndUnitId.get(p.planId)!;
      p.units.forEach(u => units.set(u.id, u));
    });

    const unitItems: ItemType[] = [];
    const planId = this.editingTicketSetting.planId;
    if (planId && this.plansByPlanId.has(planId)) {
      this.plansByPlanId.get(planId)!.units.forEach(u => {
        unitItems.push({
          text: u.title,
          value: u.id,
        });
      });
    }
    this.unitItems = unitItems;
  }

  private async fetchThenLoadTicketSetting() {
    try {
      const res = await listTicketSettings({});
      this.ticketSettingsByTicketId = new Map(res.tickets.map(t => [t.id!, t]));
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t('Fetch {msg}', {
            msg: this.$t('Ticket setting'),
          }) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
  }

  private loadTicketItems() {
    const ticketItems: ItemType[] = [];
    this.ticketSettingsByTicketId.forEach(t => {
      const plan = this.plansByPlanId.get(t.planId)! || {
        activityId: '',
        activityTitle: '-',
        planId: t.planId,
        planTitle: '-',
        bookingType: BookingTypeEnum.EACH_TIME,
      };
      const unit =
        this.planUnitByPlanIdAndUnitId.has(t.planId) &&
        this.planUnitByPlanIdAndUnitId.get(t.planId)!.has(t.unitId)
          ? this.planUnitByPlanIdAndUnitId.get(t.planId)!.get(t.unitId)!
          : {
              id: t.unitId,
              title: '-',
            };
      const ticket: TicketType = {
        activityId: plan.activityId,
        activityTitle: plan.activityTitle,
        planId: plan.planId,
        planTitle: plan.planTitle,
        unitId: unit.id,
        unitTitle: unit.title,
        bookingType: plan.bookingType || BookingTypeEnum.EACH_TIME,
        ticketId: t.id!,
        ticketTitle: t.title,
      };
      ticketItems.push({
        text: ticketToText(this.$i18n, ticket),
        value: t.id!,
      });
    });
    this.ticketItems = ticketItems.sort((a, b) =>
      compareString(a.text, b.text)
    );
    this.ticketTextByTicketId = new Map(
      ticketItems.map(t => [t.value, t.text])
    );
  }

  private resetDialog() {
    this.dialog = false;
    this.dialogTextTitle = '';
    this.dialogTextFooter = '';
    this.showRedirectAfterCreate = true;
    this.showCopyTicketSettings = false;
    this.$nextTick(() => {
      this.dialogConfirmHandler = this.resetDialog;
    });
  }

  private showDialogForCreate() {
    this.dialogTextTitle = `${this.translateRouteTitle(
      this.$route.meta.title
    )}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = true;
    this.showCopyTicketSettings = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.createTicketSetting();
    };
    this.dialog = true;
  }

  private showDialogForReset() {
    this.dialogTextTitle = `${this.$t('Reset')}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyTicketSettings = false;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.reset();
    };
    this.dialog = true;
  }

  private showDialogForCopy() {
    this.dialogTextTitle = `${this.$t('Copy from other {msg}', {
      msg: this.$t('Plan setting'),
    })}`;
    this.dialogTextFooter = `${this.$t('Is it OK?')}`;
    this.showRedirectAfterCreate = false;
    this.showCopyTicketSettings = true;
    this.dialogConfirmHandler = () => {
      this.resetDialog();
      this.copyTicketSetting();
    };
    this.dialog = true;
  }

  private copyTicketSetting() {
    const copyTicketSetting = this.ticketSettingsByTicketId.get(
      this.copyTicketSettingId
    )!;
    this.editingTicketSetting = JSON.parse(JSON.stringify(copyTicketSetting));
    this.enableMogiri = !!copyTicketSetting.mogiriSetting;
    delete this.editingTicketSetting.id;
    delete this.editingTicketSetting.version;

    this.editingTicketSetting.titlesForTraveler =
      this.editingTicketSetting.titlesForTraveler || [];

    const issuableFromDates: string[] = [];
    const issuableFromOptDates: string[] = [];
    const fromDateMenus: boolean[] = [];
    const fromOptDateMenus: boolean[] = [];
    this.editingTicketSetting.issuableFrom.forEach(f => {
      issuableFromDates.push(
        this.isRelativeFixedDate(f)
          ? stringFromIDate(f.relativeFixedDate!)!
          : this.isAbsoluteFixedDate(f)
          ? stringFromIDate(f.absoluteFixedDate!)!
          : ''
      );
      issuableFromOptDates.push(
        this.isRelativeFixedDate(f) && this.hasYearIncreamentBaseDate(f)
          ? stringFromIDate(f.yearIncreamentBaseDate!)!
          : ''
      );
      fromDateMenus.push(false);
      fromOptDateMenus.push(false);
    });
    this.editingTicketSetting.issuableFromDates = issuableFromDates;
    this.editingTicketSetting.issuableFromOptDates = issuableFromOptDates;
    this.fromDateMenus = fromDateMenus;
    this.fromOptDateMenus = fromOptDateMenus;
    const issuableToDates: string[] = [];
    const issuableToOptDates: string[] = [];
    const toDateMenus: boolean[] = [];
    const toOptDateMenus: boolean[] = [];
    this.editingTicketSetting.issuableTo.forEach(t => {
      issuableToDates.push(
        this.isRelativeFixedDate(t)
          ? stringFromIDate(t.relativeFixedDate!)!
          : this.isAbsoluteFixedDate(t)
          ? stringFromIDate(t.absoluteFixedDate!)!
          : ''
      );
      issuableToOptDates.push(
        this.isRelativeFixedDate(t) && this.hasYearIncreamentBaseDate(t)
          ? stringFromIDate(t.yearIncreamentBaseDate!)!
          : ''
      );
      toDateMenus.push(false);
      toOptDateMenus.push(false);
    });
    this.editingTicketSetting.issuableToDates = issuableToDates;
    this.editingTicketSetting.issuableToOptDates = issuableToOptDates;
    this.toDateMenus = toDateMenus;
    this.toOptDateMenus = toOptDateMenus;
    this.editingTicketSetting.isActive = !this.editingTicketSetting.isInactive;

    if (!this.editingTicketSetting.mogiriSetting) {
      this.editingTicketSetting.mogiriSetting = {
        overrideStaffLabel: [],
        checkInCodes: [],
        cautionLabels: [
          {
            ticketStatus: TicketStatusEnum.UNKNOWN,
            label: [],
          },
        ],
      };
    }
    if (
      this.editingTicketSetting.mogiriSetting?.fixedTime?.timeOfDate?.seconds
    ) {
      const seconds = this.editingTicketSetting.mogiriSetting.fixedTime
        .timeOfDate.seconds as number;
      (this.editingTicketSetting.mogiriSetting.fixedTime.timeOfDate
        .seconds as any) = secondsToTime(seconds);
    }
    if (
      this.editingTicketSetting.mogiriSetting?.validDays?.timeOfDate?.seconds
    ) {
      const seconds = this.editingTicketSetting.mogiriSetting.validDays
        .timeOfDate.seconds as number;
      (this.editingTicketSetting.mogiriSetting.validDays.timeOfDate
        .seconds as any) = secondsToTime(seconds);
    }

    this.loadUnitItems();
  }

  private reset() {
    const supplierId = (JSON.parse(UserModule.token) as IUserTokenData)
      .supplierId;
    this.editingTicketSetting = newDefaultTicketSetting(supplierId) as any;

    this.editingTicketSetting.issuableFromDates = [];
    this.editingTicketSetting.issuableFromOptDates = [];
    this.editingTicketSetting.issuableToDates = [];
    this.editingTicketSetting.issuableToOptDates = [];
    this.editingTicketSetting.isActive = !this.editingTicketSetting.isInactive;
    this.editingTicketSetting.priority = null;
    this.fromDateMenus = [];
    this.fromOptDateMenus = [];
    this.toDateMenus = [];
    this.toOptDateMenus = [];
  }

  private async createTicketSetting() {
    this.loading = true;
    AppModule.StartProgress();

    try {
      const newTicketSetting = JSON.parse(
        JSON.stringify(this.editingTicketSetting)
      ) as TicketSetting;
      const titlesForTraveler: I18nText[] = [];
      const titleLangsForTraveler: { [lang: string]: boolean } = {};
      (newTicketSetting.titlesForTraveler || []).forEach(t => {
        if (!titleLangsForTraveler[t.lang as string]) {
          titlesForTraveler.push(t);
          titleLangsForTraveler[t.lang as string] = true;
        }
      });
      newTicketSetting.titlesForTraveler = titlesForTraveler;

      newTicketSetting.issuingRules.forEach(r => {
        if (this.isCannotPartialIssue(r)) {
          r.targetTicketId = '';
        }
      });
      newTicketSetting.issuableFrom.forEach(i => {
        if (this.isRelativeFixedDate(i)) {
          delete i.period;
          delete i.absoluteFixedDate;
        } else if (this.isAbsoluteFixedDate(i)) {
          delete i.period;
          delete i.relativeFixedDate;
        } else {
          delete i.relativeFixedDate;
          delete i.absoluteFixedDate;
        }
      });
      newTicketSetting.issuableTo.forEach(i => {
        if (this.isRelativeFixedDate(i)) {
          delete i.period;
          delete i.absoluteFixedDate;
        } else if (this.isAbsoluteFixedDate(i)) {
          delete i.period;
          delete i.relativeFixedDate;
        } else {
          delete i.relativeFixedDate;
          delete i.absoluteFixedDate;
        }
      });
      delete (newTicketSetting as any).issuableFromDates;
      delete (newTicketSetting as any).issuableFromOptDates;
      delete (newTicketSetting as any).issuableToDates;
      delete (newTicketSetting as any).issuableToOptDates;

      if (!this.enableMogiri) {
        (newTicketSetting.mogiriSetting as any) = null;
      }

      if (newTicketSetting.mogiriSetting?.fixedTime?.timeOfDate?.seconds) {
        const seconds = newTicketSetting.mogiriSetting.fixedTime.timeOfDate
          .seconds as any;
        newTicketSetting.mogiriSetting.fixedTime.timeOfDate.seconds = timeToSeconds(
          seconds
        );
      }

      if (newTicketSetting.mogiriSetting?.validDays?.timeOfDate?.seconds) {
        const seconds = newTicketSetting.mogiriSetting.validDays.timeOfDate
          .seconds as any;
        newTicketSetting.mogiriSetting.validDays.timeOfDate.seconds = timeToSeconds(
          seconds
        );
      }

      const req: IPutTicketSettingRequest = {
        planId: newTicketSetting.planId,
        unitId: newTicketSetting.unitId,
        issuingRules: newTicketSetting.issuingRules,
        issuableFrom: newTicketSetting.issuableFrom,
        issuableTo: newTicketSetting.issuableTo,
        title: newTicketSetting.title,
        titlesForTraveler: newTicketSetting.titlesForTraveler,
        applyingRule: newTicketSetting.applyingRule,
        mogiriSetting: newTicketSetting.mogiriSetting,
        isInactive: newTicketSetting.isInactive,
        priority: newTicketSetting.priority,
      };

      const res = await putTicketSetting(req);
      await this.postCreate(res.ticketId);
    } catch (err) {
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.translateRouteTitle(
            this.$route.meta.title
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
      await this.postCreate();
    }

    AppModule.StopProgress();
    this.loading = false;
  }

  private async postCreate(ticketId?: string) {
    if (this.redirectAfterCreate && ticketId) {
      this.$nextTick(() => {
        this.$router.push(`/ticketsetting/${ticketId}`);
      });
    } else {
      this.reset();
      await this.fetchData(true);

      if (ticketId) {
        this.$toast.success(
          this.$t('Succeeded {do}', {
            do: (this.translateRouteTitle(
              this.$route.meta.title
            ) as string).toLowerCase(),
          }) as string,
          {
            icon: this.$route.meta.icon,
          }
        );
      }
    }
  }

  private getPlanText(planId: string) {
    return this.plansByPlanId.has(planId)
      ? planToText(this.$i18n, this.plansByPlanId.get(planId)!)
      : '';
  }

  private getUnitText(planId: string, unitId: string) {
    return this.planUnitByPlanIdAndUnitId.has(planId) &&
      this.planUnitByPlanIdAndUnitId.get(planId)!.has(unitId)
      ? this.planUnitByPlanIdAndUnitId.get(planId)!.get(unitId)!.title
      : '';
  }

  private isCannotPartialIssue(rule: IssuingRule) {
    return (rule.id as IssuingRuleId) === IssuingRuleId.CANNOT_PARTIALY_ISSUE;
  }

  private isMustIssueAfterSpecificTicket(rule: IssuingRule) {
    return (
      (rule.id as IssuingRuleId) ===
      IssuingRuleId.MUST_ISSUE_AFTER_SPECIFIC_TICKET
    );
  }

  private addEditingTitleForTraveler() {
    this.editingTicketSetting.titlesForTraveler.push({
      lang: LanguageEnum.ENGLISH,
      text: '',
    });
  }

  private removeEditingTitleForTraveler(titleForTravelerIndex: number) {
    this.editingTicketSetting.titlesForTraveler.splice(
      titleForTravelerIndex,
      1
    );
  }

  private addEditingOverrideStaffLabel() {
    this.editingTicketSetting.mogiriSetting?.overrideStaffLabel?.push({
      lang: LanguageEnum.ENGLISH,
      text: '',
    });
  }

  private removeEditingOverrideStaffLabel(index: number) {
    this.editingTicketSetting.mogiriSetting?.overrideStaffLabel?.splice(
      index,
      1
    );
  }

  private addEditingValidSeconds() {
    if (this.editingTicketSetting.mogiriSetting) {
      this.$set(this.editingTicketSetting.mogiriSetting, 'validSeconds', 5);
    }
  }

  private removeEditingValidSeconds() {
    if (this.editingTicketSetting.mogiriSetting) {
      this.$set(
        this.editingTicketSetting.mogiriSetting,
        'validSeconds',
        undefined
      );
    }
  }

  private addEditingFixedTime() {
    if (this.editingTicketSetting.mogiriSetting) {
      this.$set(this.editingTicketSetting.mogiriSetting, 'fixedTime', {
        offsetDays: 0,
        timeOfDate: {
          seconds: '',
        },
        timeZone: '',
      });
    }
  }

  private addEditingValidDays() {
    if (this.editingTicketSetting.mogiriSetting) {
      this.$set(this.editingTicketSetting.mogiriSetting, 'validDays', {
        validDays: 0,
        timeOfDate: {
          seconds: '',
        },
        timeZone: '',
      });
    }
  }

  private removeEditingFixedTime() {
    if (this.editingTicketSetting.mogiriSetting) {
      this.$set(
        this.editingTicketSetting.mogiriSetting,
        'fixedTime',
        undefined
      );
    }
  }

  private removeEditingValidDays() {
    if (this.editingTicketSetting.mogiriSetting) {
      this.$set(
        this.editingTicketSetting.mogiriSetting,
        'validDays',
        undefined
      );
    }
  }

  private addEditingIssuingRule() {
    this.editingTicketSetting.issuingRules.push({
      id: IssuingRuleId.CANNOT_PARTIALY_ISSUE,
      targetTicketId: '',
    });
  }

  private removeEditingIssuingRule(issuingRuleIndex: number) {
    this.editingTicketSetting.issuingRules.splice(issuingRuleIndex, 1);
  }

  private addEditingCheckIncodes() {
    const codes = this.editingTicketSetting.mogiriSetting
      ?.checkInCodes as MogiriSettingCode[];
    codes.push({
      code: '',
      description: '',
    });
  }

  private removeEditingCheckIncodes(index: number) {
    const codes = this.editingTicketSetting.mogiriSetting
      ?.checkInCodes as MogiriSettingCode[];
    codes.splice(index, 1);
  }

  private addEditingCautionLabels() {
    this.editingTicketSetting.mogiriSetting?.cautionLabels?.push({
      ticketStatus: TicketStatusEnum.UNKNOWN,
      label: [
        {
          lang: LanguageEnum.ENGLISH,
          text: '',
        },
      ],
    });
  }

  private removeEditingCautionLabels(cautionLabelIndex: number) {
    this.editingTicketSetting.mogiriSetting?.cautionLabels?.splice(
      cautionLabelIndex,
      1
    );
  }

  private addEditingCautionLabel(cautionLabelIndex: number) {
    const cautionLabels = this.editingTicketSetting.mogiriSetting
      ?.cautionLabels as MogiriSettingCautionLabel[];
    if (cautionLabels[cautionLabelIndex].label) {
      cautionLabels[cautionLabelIndex].label.push({
        lang: LanguageEnum.ENGLISH,
        text: '',
      });
    }
  }

  private removeEditingCautionLabel(cautionLabelIndex: number, index: number) {
    const cautionLabels = this.editingTicketSetting.mogiriSetting
      ?.cautionLabels as MogiriSettingCautionLabel[];
    if (cautionLabels[cautionLabelIndex].label) {
      cautionLabels[cautionLabelIndex].label.splice(index, 1);
    }
  }

  private isRelativeFixedDate(date: IssuableDate) {
    return (
      (date.base as IssuableDateBaseDateTypeEnum) ===
      IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE
    );
  }

  private isAbsoluteFixedDate(date: IssuableDate) {
    return (
      (date.base as IssuableDateBaseDateTypeEnum) ===
      IssuableDateBaseDateTypeEnum.ABSOLUTE_FIXED_DATE
    );
  }

  private hasYearIncreamentBaseDate(date: IssuableDate) {
    return !!date.yearIncreamentBaseDate;
  }

  private addEditingIssuableFrom() {
    this.editingTicketSetting.issuableFrom.push({
      base: IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE,
      period: undefined,
      relativeFixedDate: stringToIDate(formatDate(new Date()))!,
    });
    this.editingTicketSetting.issuableFromDates.push(formatDate(new Date())!);
    this.editingTicketSetting.issuableFromOptDates.push('');
    this.fromDateMenus.push(false);
    this.fromOptDateMenus.push(false);
  }

  private removeEditingIssuableFrom(issuableFromIndex: number) {
    this.editingTicketSetting.issuableFrom.splice(issuableFromIndex, 1);
    this.editingTicketSetting.issuableFromDates.splice(issuableFromIndex, 1);
    this.editingTicketSetting.issuableFromOptDates.splice(issuableFromIndex, 1);
    this.fromDateMenus.splice(issuableFromIndex, 1);
    this.fromOptDateMenus.splice(issuableFromIndex, 1);
  }

  private handleIssuableFromRelativeFixedDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingTicketSetting.issuableFrom[
      issuableFromIndex
    ].relativeFixedDate = stringToIDate(date)!;

    this.fromDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromAbsoluteFixedDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingTicketSetting.issuableFrom[
      issuableFromIndex
    ].absoluteFixedDate = stringToIDate(date)!;

    this.fromDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromYearIncreamentBaseDateInput(
    date: string,
    issuableFromIndex: number
  ) {
    this.editingTicketSetting.issuableFrom[
      issuableFromIndex
    ].yearIncreamentBaseDate = stringToIDate(date)!;

    this.fromOptDateMenus[issuableFromIndex] = false;
  }

  private handleIssuableFromBaseInput(
    base: IssuableDateBaseDateTypeEnum,
    issuableFromIndex: number
  ) {
    if (
      (base as IssuableDateBaseDateTypeEnum) !==
        IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE &&
      !this.editingTicketSetting.issuableFrom[issuableFromIndex].period
    ) {
      this.editingTicketSetting.issuableFrom[issuableFromIndex].period = {
        count: 1,
        unit: TimePeriodUnitEnum.DAY,
      };
    }
  }

  private addEditingIssuableTo() {
    this.editingTicketSetting.issuableTo.push({
      base: IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE,
      period: undefined,
      relativeFixedDate: stringToIDate(formatDate(new Date()))!,
    });
    this.editingTicketSetting.issuableToDates.push(formatDate(new Date())!);
    this.editingTicketSetting.issuableToOptDates.push('');
    this.toDateMenus.push(false);
    this.toOptDateMenus.push(false);
  }

  private removeEditingIssuableTo(issuableToIndex: number) {
    this.editingTicketSetting.issuableTo.splice(issuableToIndex, 1);
    this.editingTicketSetting.issuableToDates.splice(issuableToIndex, 1);
    this.editingTicketSetting.issuableToOptDates.splice(issuableToIndex, 1);
    this.toDateMenus.splice(issuableToIndex, 1);
    this.toOptDateMenus.splice(issuableToIndex, 1);
  }

  private handleIssuableToRelativeFixedDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingTicketSetting.issuableTo[
      issuableToIndex
    ].relativeFixedDate = stringToIDate(date)!;

    this.toDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToAbsoluteFixedDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingTicketSetting.issuableTo[
      issuableToIndex
    ].absoluteFixedDate = stringToIDate(date)!;

    this.toDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToYearIncreamentBaseDateInput(
    date: string,
    issuableToIndex: number
  ) {
    this.editingTicketSetting.issuableTo[
      issuableToIndex
    ].yearIncreamentBaseDate = stringToIDate(date)!;

    this.toOptDateMenus[issuableToIndex] = false;
  }

  private handleIssuableToBaseInput(
    base: IssuableDateBaseDateTypeEnum,
    issuableToIndex: number
  ) {
    if (
      (base as IssuableDateBaseDateTypeEnum) !==
        IssuableDateBaseDateTypeEnum.RELATIVE_FIXED_DATE &&
      !this.editingTicketSetting.issuableTo[issuableToIndex].period
    ) {
      this.editingTicketSetting.issuableTo[issuableToIndex].period = {
        count: 1,
        unit: TimePeriodUnitEnum.DAY,
      };
    }
  }

  private getFixedDateText(fixedDate?: IDate) {
    return fixedDate ? stringFromIDate(fixedDate)!.slice(5) : '';
  }

  private getFixedDateWithYearText(fixedDate?: IDate) {
    return fixedDate ? stringFromIDate(fixedDate)! : '';
  }

  private getPeriodText(period?: TimePeriod) {
    return period
      ? `${period.count} ${this.$t(
          'TimePeriodUnitEnum.' + (period.unit as string)
        )}`
      : '';
  }

  private stringIsNumber(v?: string) {
    return v !== void 0 && !isNaN(stringToNumber(v));
  }

  private getRequiredRules(
    msg: any,
    exception: (v: any) => boolean = () => false
  ) {
    return [
      (v: string) =>
        exception(v) ||
        !!v ||
        (this.$t('{msg} is required', {
          msg: this.$te(msg) ? this.$t(msg) : msg,
        }) as string),
    ];
  }

  private getMinRules(
    msg: string,
    min?: number,
    exception: (v: any, min: any) => boolean = () => false
  ) {
    return [
      (v: number) =>
        exception(v, min) ||
        v >= min! ||
        (this.$t('{msg} must be equal or greater than {num}', {
          msg: this.$t(msg),
          num: min,
        }) as string),
    ];
  }

  private translateRouteTitle(title: string) {
    return translateRouteTitle(this.$i18n, title);
  }
}
